import { z } from 'zod';

export const condenseContentConfigSchema = z.object({
    enabled: z.boolean(),
    components: z.array(z.string()),
});

export type CondenseContentConfig = z.infer<typeof condenseContentConfigSchema>;
